/**
 * Users API Mutations
 *
 * Create/update operations.
 */

// API client
import { apiClient } from '../client';

// Types
import type { CreateUserData, UpdateUserData, UserResponse } from './types';

export async function createUser(data: CreateUserData): Promise<UserResponse> {
  const response = await apiClient.post<UserResponse>('/api/users', { user: data });
  return response.data;
}

export async function updateUser(data: UpdateUserData): Promise<UserResponse> {
  const { id, ...updateData } = data;
  const response = await apiClient.patch<UserResponse>(`/api/users/${id}`, { user: updateData });
  return response.data;
}
